import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Heart, Youtube, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { isIosApp } from '../utils/platform';
import { Logo6 } from './LogoShowcase';

const PAYPAL_EMAIL = 'colotludovic@gmail.com';
const YOUTUBE_CHANNEL = 'https://youtube.com/@hypnose.ericksonienne?si=fAHkQ8WkyEdEov0D';

export const Header = ({ onAdminAccess }) => {
  const [isPremium, setIsPremium] = useState(false);
  const tapCountRef = useRef(0);
  const tapTimerRef = useRef(null);
  
  const paypalUrl = `https://www.paypal.com/donate/?business=${encodeURIComponent(PAYPAL_EMAIL)}&currency_code=EUR`;

  useEffect(() => {
    const premium = localStorage.getItem('hypnose_cle_premium');
    setIsPremium(premium === 'true');
  }, []);

  const handleLogoTap = useCallback(() => {
    tapCountRef.current += 1;
    if (tapTimerRef.current) clearTimeout(tapTimerRef.current);
    if (tapCountRef.current >= 5) {
      tapCountRef.current = 0;
      if (onAdminAccess) onAdminAccess();
    } else {
      tapTimerRef.current = setTimeout(() => { tapCountRef.current = 0; }, 1500);
    }
  }, [onAdminAccess]);
  
  return (
    <header className="fixed top-0 left-0 right-0 z-40 px-4 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative cursor-default select-none" onClick={handleLogoTap}>
            <Logo6 />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-white">
                Hypnose <span className="gradient-text">clé</span>
              </h1>
              {isPremium && (
                <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-yellow-500/20 to-amber-500/20 border border-yellow-500/30" title="Merci pour votre don !">
                  <Crown className="w-3 h-3 text-yellow-400" />
                  <span className="text-xs text-yellow-400 font-medium">Premium</span>
                </div>
              )}
            </div>
            <a
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs text-white/50 hover:text-red-400 transition-colors"
              data-testid="youtube-channel-link"
            >
              <Youtube className="w-3 h-3" />
              <span>Hypnose Ericksonienne</span>
            </a>
          </div>
        </div>
        
        {isPremium ? (
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-yellow-500/10 to-amber-500/10 border border-yellow-500/20">
            <Crown className="w-4 h-4 text-yellow-400" />
            <span className="text-yellow-400 text-sm font-medium">Merci !</span>
          </div>
        ) : !isIosApp() ? (
          <Link
            to="/soutenir"
            className="paypal-btn animate-pulse-glow"
            data-testid="header-soutenir-btn"
          >
            <Heart className="w-4 h-4 text-pink-400" />
            <span>Soutenir</span>
          </Link>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
